// @ts-nocheck - suppress strict/type resolution errors in this legacy JS-heavy file
/// <reference path="../typings/global.d.ts" />

declare var OnRequiredFieldsDataBound: any;

import { ApplicationListItem, FormFieldModel } from "../types/CommonTypes";
import { FieldEditableTypeCode } from "../types/CommonTypes";
import { RequiredFieldModel } from "../types/CommonTypes";
import { DropdownListUtility } from "./DropdownListUtility";
import { DateFieldValidation } from "./DateFieldValidation";
import { CustomQuestionManager } from "./CustomQuestionManager";

export class RequiredFieldBinder {

    public SetProgramRequiredFields(url: string, OnRequiredFieldsDataBound?: (() => void) | null, isEditPage: boolean = false) : void {

        $.ajax({
            url: url,
            type: 'GET'
        }).done((data) => {

            //Need to call validate to reinitalize validator after ajax call.
            //$('#application-form').validate();
            //jQuery.validator.unobtrusive.parse('application-form');
            if (data.length > 0) {
                $.each(data, (index, value) => {
                    this.SetApplicationRequiredFieldValues(value, 'ApplicationInformation', false, isEditPage, false);
                    this.SetRequiredFieldHelpText(value, 'ApplicationInformation');
                });
                CustomQuestionManager.SetCustomDateRanges();
            }

            this.ShowAppForm();

            //handle stuff that needs to happen after the fields are bound
            if (typeof OnRequiredFieldsDataBound === 'function') {
                OnRequiredFieldsDataBound();
            }

        }).fail((xhr) => {
            if (xhr.status == 401 || xhr.status == 440) {
                window.location.href = window.origin + "/Home/SessionTimeout";
            } else {
                console.log("Error - SetProgramRequiredFields");
                console.log("Error Text: " + xhr.responseText);
                console.log("Error: " + xhr.statusText);
                console.log("Status: " + xhr.status);
                console.log("Status Code: " + xhr.statusCode);
                alert('Error: ' + xhr.status + ' ' + xhr.statusText);
            }
        });
    }


    public SetProgramRequiredFieldsByPage(url: string, pageName: string, helpImageUrl?: string | null, isEditPage: boolean = false, OnRequiredFieldsDataBound?: (() => void) | null) : void {

        //Note: TS vs JS. To get this context, must user (result)=> instead of function(result)
        $.getJSON(url)
            .done((data) => {

                //Need to call validate to reinitalize validator after ajax call.
                //Note: validate() was throwing an error on one and done??
                //$('#application-form').validate();
                if (data.length > 0) {
                    $.each(data, (index, value) => {
                        this.SetApplicationRequiredFieldValues(value, pageName, false, isEditPage, false);
                        this.SetRequiredFieldHelpText(value, pageName);
                    });
                    CustomQuestionManager.SetCustomDateRanges();
                }

                this.ShowAppForm();

                //handle stuff that needs to happen after the fields are bound
                if (typeof OnRequiredFieldsDataBound === 'function') {
                    OnRequiredFieldsDataBound();
                }

            })
            .fail(() => {
                console.log("error");
            });
    }


    public SetProgramRequiredFieldsByPageApplyRules(url: string, pageName: string, OnRequiredFieldsDataBound?: (() => void) | null, isEditPage: boolean = false, isPremiseFromCIS = false) : void {

        //Note: TS vs JS. To get this context, must user (result)=> instead of function(result)
        $.getJSON(url)
            .done((data) => {

                //Need to call validate to reinitalize validator after ajax call.
                //Note: validate() was throwing an error on one and done??
                //$('#application-form').validate();
                if (data.length > 0) {
                    $.each(data, (index, value) => {
                        this.SetApplicationRequiredFieldValues(value, pageName, true, isEditPage, isPremiseFromCIS);
                        //FIXME
                        //this.SetRequiredFieldHelpText(value, pageName, helpImageUrl);
                        this.SetRequiredFieldHelpText(value, pageName);
                    });
                    CustomQuestionManager.SetCustomDateRanges();
                }

                this.ShowAppForm();

                //handle stuff that needs to happen after the fields are bound
                if (typeof OnRequiredFieldsDataBound === 'function') {
                    OnRequiredFieldsDataBound();
                } else if (typeof (window as any).OnRequiredFieldsDataBound === 'function') {
                    (window as any).OnRequiredFieldsDataBound();
                }

            });

    }

    public SetApplicationRequiredFieldValues(field: RequiredFieldModel, pageName, applyValidation: boolean, isEditPage: boolean, isPremiseFromCIS: boolean) {
        // default case for backward compatibility
        //Legacy = 0 - Do not use
        //Field = 1 - Show / Hides, Updates Text, Set Jquery required field
        //Title = 2 - Updates text (can update to blank)
        //FieldSet = 3, - Block element.Show / Hides field (Does not update label, used for div or fieldset to show or hide)
        //Paragraph = 4 - Paragraph - Similar to Label.Allows for formatted text.
        //ReadOnlyField = 5 - Read Only Field - Show / Hide, Update Label, No Validation
        //Field Range = 6 - Same as field, but adds min/max validation
        //Field Date Range = 7 - Same as field, but adds min/max date validation

        if (field.UsageCode == null || field.UsageCode == 0 || field.UsageCode == 1) {
            //Treat this as a form field.
            this.HandleRequiredFieldValue(field, pageName, applyValidation, isEditPage, isPremiseFromCIS);
        } else if (field.UsageCode == 2) {
            this.HandleRequiredTitleValue(field);
        } else if (field.UsageCode == 3) {
            this.HandleRequiredFieldsetValue(field);
        } else if (field.UsageCode == 4) {
            this.HandleRequiredTitleValue(field);
        } else if (field.UsageCode == 5) {
            this.HandleRequiredTitleValue(field);
            this.HandleRequiredFieldsetValue(field);
        } else if (field.UsageCode == 6) {
            this.HandleRequiredFieldValue(field, pageName, applyValidation, isEditPage, isPremiseFromCIS);
            this.SetNumericFieldRangeValidation(field, pageName);
        } else if (field.UsageCode == 7) {
            this.HandleRequiredFieldValue(field, pageName, applyValidation, isEditPage, isPremiseFromCIS);
            var inptName = this.GetPageFieldName(pageName, field.FieldName);
            DateFieldValidation.SetDateFieldValidation(field, inptName);
        }
    }

    HideUnusedAppFormFieldsets() {
        //Hide unused fuel sections.
        var ac = $("#pageAirConditioningFieldSet").find(".app-opt-attr[display!=' none']").filter(function () {
            return $(this).css("display") !== 'none';
        });
        if (!ac.length) {
            $("#pageAirConditioningFieldSet").hide();
        }

        var wh = $("#pageWaterHeatingFieldSet").find(".app-opt-attr[display!=' none']").filter(function () {
            return $(this).css("display") !== 'none';
        });
        if (!wh.length) {
            $("#pageWaterHeatingFieldSet").hide();
        }

        var hh = $("#pageHouseHeatingFieldSet").find(".app-opt-attr[display!=' none']").filter(function () {
            return $(this).css("display") !== 'none';
        });
        if (!hh.length) {
            $("#pageHouseHeatingFieldSet").hide();
        }

        var rra = $("#pageRebateReassignmentFieldSet").find("#ApplicationInformation_ReassignRebateTypeId");
        if (!rra.length) {
            $("#pageRebateReassignmentFieldSet").hide();
        }

        var hinfo = $("#editHouseInfoFieldset").find(".app-opt-attr[display!=' none']").filter(function () {
            return $(this).css("display") !== 'none';
        });
        if (!hinfo.length) {
            $("#editHouseInfoFieldset").hide();
        }
    }

    private HandleRequiredFieldValue(field: RequiredFieldModel, pageName, applyValidation: boolean, isEditPage: boolean, isPremiseFromCIS: boolean) {

        //Hide or Show div
        this.ToggleFieldVisiblity(field, pageName);

        //Enable or disable the html control
        this.ToggleFieldEditability(field, pageName, isEditPage, isPremiseFromCIS);

        if (field.IsEnabled) {
            //Update label
            this.UpdateFieldLabelText(field, pageName);

            //Set JQV
            if (applyValidation) {
                this.ToggleRequiredFieldValidation(field.IsRequired, pageName, field.FieldName);
            }
            if (!field.IsRequired) {
                var inpt = this.GetPageFieldControl(pageName, field.FieldName);
                inpt.attr("placeholder", field.PlaceholderText);
            }

            if (field.ItemList != null) {
                var inputName = "#" + this.GetPageFieldName(pageName, field.FieldName);
                DropdownListUtility.UpdateApplicationRequiredFieldDropdownList(inputName, field.ItemList);
            }
        }
    }

    private HandleRequiredTitleValue(field: RequiredFieldModel) {
        $('#' + field.FieldName).html(field.LabelText);

        //if its hidden, make sure we show it.
        var eqDiv = $('#' + field.FieldName).closest("div.app-opt-attr");
        if (eqDiv.length) {
            if (field.IsEnabled) {
                eqDiv.show();

            } else {
                eqDiv.hide();
            }
        }
    }

    private HandleRequiredFieldsetValue(field: RequiredFieldModel) {
        if (field.IsEnabled == true) {
            $('#' + field.FieldName).show();
        }
        else {
            $('#' + field.FieldName).hide();
        }
    }

    private UpdateFieldLabelText(field: RequiredFieldModel, pageName) {

        //Even though we are selecting by id, use attr+each since we have multiple groups of radio btns sharing an ID.
        var inputName = this.GetPageFieldName(pageName, field.FieldName);

        $("[id=" + inputName + "]").each(function () {
            if ($(this).length) {
                if (field.LabelText) {
                    var eqDiv = $(this).closest("div.app-opt-attr, div.dynamic-label-div");
                    var lbl = eqDiv.find(".control-label, .col-form-label, .form-label, .dynamic-question-label").text(field.LabelText);
                    if (field.IsRequired) {
                        lbl.addClass("label-required");
                    }
                }
            }
        });


        //Do the same update using name, there are instances where id has been overridden.
        var namedInput: string = "input[name='" + inputName + "']";
        namedInput = namedInput.split("_").join(".");
        $(namedInput).each(function () {
            if ($(this).length) {
                if (field.LabelText) {
                    var eqDiv = $(this).closest("div.app-opt-attr, div.dynamic-label-div");
                    var lbl = eqDiv.find(".control-label, .col-form-label, .dynamic-question-label").text(field.LabelText);
                    if (field.IsRequired) {
                        lbl.addClass("label-required");
                    }
                }
            }
        });

    }


    SetRequiredFieldHelpText(field: RequiredFieldModel, pageName) {

        if (field.UsageCode == 0 || field.UsageCode == 1 || field.UsageCode == 6 || field.UsageCode == 7) {
            if (field.IsEnabled && field.ContextHelpText.length > 0) {


                var ttId = this.GetPageFieldName(pageName, field.FieldName);
                var ttCtrl = $("#" + ttId);

                if (ttCtrl.length != 0) {
                    ttCtrl.prop("title", field.ContextHelpText);
                    ttCtrl.tooltip({ placement: "bottom", html: true });
                }
            }
        }
    }

    SetRequiredFieldHelpTextPopover(field: RequiredFieldModel, pageName, helpImageUrl: string) {

        if (!helpImageUrl) {
            if ($("#icf-common-help-url").length) {
                helpImageUrl = $("#icf-common-help-url").val()[0];
            }
        }

        if (typeof helpImageUrl !== "undefined") {
            if (field.UsageCode == 0 || field.UsageCode == 1) {
                if (field.IsEnabled && field.ContextHelpText.length > 0) {

                    var popId = this.GetPageFieldName(pageName, field.FieldName) + '_Help';
                    var popoverCtrl = $("#" + popId);

                    if (popoverCtrl.length == 0) {
                        var eqDiv = $("#" + this.GetPageFieldName(pageName, field.FieldName)).closest("div.app-opt-attr, div.dynamic-label-div");
                        var lbl = eqDiv.find(".control-label, .dynamic-question-label");
                        var ctrl_div = lbl.siblings(".controls").first();
                        ctrl_div.append('<span id="' + popId + '" class="popover-link">' + field.HyperLinkText + ' ' + helpImageUrl + '</span>');
                    } else {
                        popoverCtrl.html(field.HyperLinkText + ' ' + helpImageUrl);
                    }

                    $('#' + popId).popover({
                        placement: 'bottom',
                        container: 'body',
                        html: true,
                        title: '<span class="text-info"><strong>' + field.ContextHelpTitle + '</strong></span>' +
                            '<button type="button" id="close" class="close" onclick="$(&quot;#' + popId + '&quot;).popover(&quot;hide&quot;);">&times;</button>',
                        content: field.ContextHelpText
                    });

                }
            }
        }
    }

    ToggleRequiredFieldValidation(isRequired, pageName, fieldName) {

        var inpt = this.GetPageFieldControl(pageName, fieldName);
        if (inpt.length) {

            inpt.rules("remove", "required");

            if (isRequired) {
                inpt.rules("add", {
                    required: true,
                    messages: {
                        required: "Required"
                    },
                    normalizer: function (value) {
                        return typeof value === "string" ? value.trim() : "";
                    }
                });
            } else {
                //Do nothing?
                //inpt.val('');
                //inpt.prop('checked', false);
                //inpt.rules("remove", "required range min max");
            }
        }
    }

    ToggleFieldVisiblity(field: RequiredFieldModel, pageName) {
        var inpt = this.GetPageFieldControl(pageName, field.FieldName);
        if (inpt.length) {
            //Div must be marked as optional
            var eqDiv = inpt.closest("div.app-opt-attr");
            if (eqDiv.length) {
                if (field.IsEnabled) {
                    eqDiv.show();

                    //Show enclosing fieldset if it exists
                    this.ShowFieldset(inpt);

                } else {
                    inpt.val('');
                    eqDiv.hide();
                }
            }
        }
    }

    ShowFieldset(inptFld: JQuery<HTMLElement>) {
        var eqFldSet = inptFld.closest("fieldset.fldset-opt-attr");
        if (eqFldSet.length) {
            eqFldSet.show();
        }
    }

    private ToggleFieldEditability(field: RequiredFieldModel, pageName: string, isEditPage: boolean, isPremiseFromCIS: boolean) {
        var inpt = this.GetPageFieldControl(pageName, field.FieldName);
        if (inpt.length) {
            if (field.IsEditable == FieldEditableTypeCode.ReadOnly ||
                (field.IsEditable == FieldEditableTypeCode.ReadonlyOnEdit && isEditPage == true) ||
                (field.IsEditable == FieldEditableTypeCode.ReadonlyOnSSO && isPremiseFromCIS)) {

                var fldName = this.GetPageInputFieldName(pageName, field.FieldName);

                var namedInput: string = "input[name='" + fldName + "']";
                namedInput = namedInput.split("_").join(".");

                //If we have a required field that is empty, do not disable it.
                if ($(namedInput).is(':radio')) {
                    // The field is a radio button
                    var radioNamedInput: string = "input[name='" + fldName + "']:checked";
                    if (field.IsRequired && $(radioNamedInput).val() == undefined) {
                        return;
                    }
                } else {
                    // The field is not a radio button
                    if (field.IsRequired && $(namedInput).val() == "") {
                        return;
                    }
                }

                //If we have an empty field in the SSO case, dont make it readonly.
                if (field.IsEditable == FieldEditableTypeCode.ReadonlyOnSSO && isPremiseFromCIS) {

                    //check for a select list first
                    var namedSelect: string = "select[name='" + fldName + "']";
                    namedSelect = namedSelect.split("_").join(".");
                    if ($(namedSelect).length) {
                        if (!$(namedSelect).val()) {
                            return;
                        }
                    } else if (!$(namedInput).val()) {
                        return;
                    }
                }

                //Set the field to readonly. Handle all of the different types of fields.
                inpt.prop('readonly', true);
                $(namedInput).prop('readonly', true);

                if ($(namedInput).is(':radio')) {
                    $(namedInput).prop('disabled', true);
                }

                if ($(inpt).is(':checkbox')) {
                    $(inpt).prop('disabled', true);
                }

                //Handle special case for select. Dont actually disable because post data will not be sent.
                var namedSelect: string = "select[name='" + fldName + "']";
                namedSelect = namedSelect.split("_").join(".");
                if ($(namedSelect).length) {
                    $(namedSelect).prop('readonly', false);

                    var optSelected = $("select[name='" + fldName + "'] option:selected");
                    if (optSelected.length > 0 && optSelected.val() != "") {
                        $("select[name='" + fldName + "']").addClass("icf-disable-control")
                            .on("change", (e) => { e.preventDefault(); return false; })
                            .on("keydown", (e) => { e.preventDefault(); return false; });
                    }
                }
            }
        }
    }

    private SetNumericFieldRangeValidation(field: RequiredFieldModel, pageName: string) {

        var fieldName: string = "Value";
        var inputName = this.GetPageFieldName(pageName, field.FieldName);
        var inpt = $("input[id=" + inputName + "]");
        if (inpt.length) {

            inpt.rules("remove", "range min max");

            if (field.HasMinValue && !field.HasMaxValue) {

                inpt.rules("add", {
                    min: field.MinValue,
                    messages: {
                        range: jQuery.validator.format(fieldName + " must be between greater than {0}")
                    }
                });

            } else if (!field.HasMinValue && field.HasMaxValue) {

                inpt.rules("add", {
                    max: field.MaxValue,
                    messages: {
                        range: jQuery.validator.format(fieldName + " must be less than {0}")
                    }
                });

            } else if (field.HasMinValue && field.HasMaxValue) {

                inpt.rules("add", {
                    range: [field.MinValue, field.MaxValue],
                    messages: {
                        range: jQuery.validator.format(fieldName + " must be between {0} and {1}")
                    }
                });

            }
        }
    }

    private ShowDates(dateText, dateInstance) {
        $("#" + dateInstance.id).removeClass('input-validation-error').addClass('valid');
        $("#" + dateInstance.id).closest(".equipment-attr").children(".field-validation-error").removeClass('field-validation-error').addClass('field-validation-valid').empty();
    }

    private GetPageFieldControl(pageName: string, field: string): JQuery<HTMLElement> {

        var inputName = this.GetPageFieldName(pageName, field);

        var ctrl = $("#" + inputName);
        if (!ctrl.length) {
            //In some cases id needed to be changed, so see if we can find by name.
            var namedInput: string = "input[name='" + inputName + "']";
            namedInput = namedInput.split("_").join(".");
            return $(namedInput);
        }

        return $("#" + inputName);
    }

    private GetPageFieldName(pageName: string, field: string): string {
        if (pageName) {
            return pageName + '_' + field;
        }
        else {
            return field;
        }
    }

    private GetPageInputFieldName(pageName: string, field: string): string {
        if (pageName) {
            return pageName + '.' + field;
        }
        else {
            return field;
        }
    }

    private ShowAppForm() {

        this.HideUnusedAppFormFieldsets();
        $("#application-form").removeClass("d-none").show();

        //Need to figure out how to clear hidden text boxes, but not type=hidden.
        //$("input[type='text']:hidden").val('');
    }

}